import { type GenericDetailQueryKey, generateDetailQueryKey } from '@pba/react-query';
import { medicalGroupsFeatureKey } from '../key';

type MedicalGroupDetailQueryType = GenericDetailQueryKey;

export const getMedicalGroupsDetailQueryKey = generateDetailQueryKey({
  prefix: medicalGroupsFeatureKey,
})<MedicalGroupDetailQueryType>;
